import { render, staticRenderFns } from "./DeudaListCustom.vue?vue&type=template&id=beb5e622"
import script from "./DeudaListCustom.vue?vue&type=script&lang=js"
export * from "./DeudaListCustom.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports